import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { addSupportTicket, fetchSupportTickets } from '../actions/supporttickets'
import { fetchMachines } from '../actions/machines'
import LoadingProgress from '../components/LoadingProgress'

import '../styles/SupportTicketCustomerView.css'

const STATUS_LABELS = {
  OPEN: 'Abierto',
  IN_REVIEW: 'En Revisión',
  IN_INCIDENCE: 'En Incidencia',
  IN_REPAIR: 'En Reparación',
  RESOLVED: 'Resuelto',
  CLOSED: 'Cerrado',
}

const PRIORITY_LABELS = {
  LOW: 'Baja',
  MEDIUM: 'Media',
  HIGH: 'Alta',
  CRITICAL: 'Crítica',
}

const CATEGORY_LABELS = {
  COINS: 'Pago Monedas',
  BILLS: 'Pago Billetes',
  TPV: 'Pago Tarjeta',
  SCREEN_OFF: 'Pantalla Apagada',
  SCREEN_BREAK: 'Pantalla Rota',
  SCREEN_TOUCH: 'Táctil No Responde',
  PRINTER_TICKET: 'Impresora Ticket',
  KIOSC_DOOR: 'Kiosco Puerta',
  KIOSC_OFF: 'Kiosco No Enciende',
  OTHER: 'Otro',
}

const CATEGORY_ICONS = {
  COINS: 'fas fa-coins',
  BILLS: 'fas fa-money-bill',
  TPV: 'fas fa-credit-card',
  SCREEN_OFF: 'fas fa-desktop',
  SCREEN_BREAK: 'fas fa-window-close',
  SCREEN_TOUCH: 'fas fa-hand-pointer',
  PRINTER_TICKET: 'fas fa-print',
  KIOSC_DOOR: 'fas fa-door-open',
  KIOSC_OFF: 'fas fa-power-off',
  OTHER: 'fas fa-question-circle',
}

const FILTER_TABS = [
  { key: 'ALL', label: 'Todos' },
  { key: 'OPEN', label: 'Abiertos' },
  { key: 'IN_REVIEW', label: 'En Revisión' },
  { key: 'IN_INCIDENCE', label: 'En Incidencia' },
  { key: 'IN_REPAIR', label: 'En Reparación' },
  { key: 'RESOLVED', label: 'Resueltos' },
  { key: 'CLOSED', label: 'Cerrados' },
]

class SupportTicketAddForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isSubmitted: false,
      activeFilter: 'ALL',
      expandedTicket: null,
      formMachine: '',
      formCategory: '',
      formPriority: 'MEDIUM',
      formDescription: '',
      formError: null,
      submitting: false,
    }

    this.submit = this.submit.bind(this)
    this.resetForm = this.resetForm.bind(this)
  }

  componentDidMount() {
    const { fetchMachines, fetchSupportTickets, id } = this.props

    fetchMachines()
    fetchSupportTickets('', id, '', '', '', '')
  }

  componentDidUpdate(prevProps) {
    const { supportticketNeedRefresh, fetchSupportTickets, id } = this.props

    if (supportticketNeedRefresh && !prevProps.supportticketNeedRefresh) {
      fetchSupportTickets('', id, '', '', '', '')
    }
  }

  submit(e) {
    e.preventDefault()

    const { addSupportTicket, id } = this.props
    const { formMachine, formCategory, formPriority, formDescription } = this.state

    if (!formMachine || !formCategory) {
      this.setState({ formError: 'Por favor, selecciona máquina y categoría.' })
      return
    }

    this.setState({ submitting: true, formError: null })

    const ticket = {
      Machine: formMachine,
      Category: formCategory,
      Priority: formPriority,
      Description: formDescription,
      Customer: id,
      OpenAt: new Date(),
    }

    addSupportTicket(ticket)
      .then(response => {
        if (response.error) {
          this.setState({ formError: response.error.message, submitting: false })
        } else {
          this.setState({ isSubmitted: true, submitting: false })
        }
      })
      .catch(() => {
        this.setState({ formError: 'Error al crear el ticket.', submitting: false })
      })
  }

  resetForm() {
    this.setState({
      isSubmitted: false,
      formMachine: '',
      formCategory: '',
      formPriority: 'MEDIUM',
      formDescription: '',
      formError: null,
    })
  }

  getFilteredTickets() {
    const { supporttickets } = this.props
    const { activeFilter } = this.state

    if (!supporttickets) return []
    if (activeFilter === 'ALL') return supporttickets
    return supporttickets.filter(t => t.Status === activeFilter)
  }

  getStatusCounts() {
    const { supporttickets } = this.props
    if (!supporttickets) return {}

    return supporttickets.reduce((acc, t) => {
      acc[t.Status] = (acc[t.Status] || 0) + 1
      return acc
    }, {})
  }

  toggleTicketExpand(number) {
    this.setState(prev => ({
      expandedTicket: prev.expandedTicket === number ? null : number
    }))
  }

  renderTicketCard(ticket) {
    const isExpanded = this.state.expandedTicket === ticket.number
    const catIcon = CATEGORY_ICONS[ticket.Category] || 'fas fa-tag'

    return (
      <div className="ticket-card" key={ticket.number}
        onClick={() => this.toggleTicketExpand(ticket.number)}>
        <div className="ticket-card-top">
          <div className={`ticket-status-bar ${ticket.Status}`}></div>
          <div className="ticket-card-content">
            <div className="ticket-card-row">
              <div className="ticket-card-info">
                <div className="ticket-number-line">
                  <span className="ticket-number">#{ticket.number}</span>
                  <span className="ticket-category-tag">
                    <i className={catIcon}></i>
                    {CATEGORY_LABELS[ticket.Category] || ticket.Category}
                  </span>
                </div>
                <div className="ticket-meta-row">
                  <span className="ticket-meta-item">
                    <i className="fas fa-calendar-alt"></i>
                    {new Date(ticket.OpenAt).toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' })}
                  </span>
                  {ticket.Machine &&
                    <span className="ticket-meta-item">
                      <i className="fas fa-hdd"></i>
                      {ticket.Machine.Serial || 'N/A'}
                    </span>
                  }
                  {ticket.Executor &&
                    <span className="ticket-meta-item">
                      <i className="fas fa-user-cog"></i>
                      {ticket.Executor.fullname}
                    </span>
                  }
                </div>
              </div>

              <div className="ticket-card-description">
                {ticket.Description
                  ? <span className="ticket-incidence-text">{ticket.Description}</span>
                  : <span className="ticket-incidence-empty">Sin descripción</span>
                }
              </div>

              <div className="ticket-card-badges">
                <span className={`ticket-status-badge ${ticket.Status}`}>
                  {STATUS_LABELS[ticket.Status] || ticket.Status}
                </span>
                <span className={`ticket-priority-badge ${ticket.Priority}`}>
                  {PRIORITY_LABELS[ticket.Priority] || ticket.Priority}
                </span>
              </div>
            </div>
          </div>
        </div>

        {isExpanded && (
          <div className="ticket-card-detail">
            <div className="ticket-detail-grid">
              <div className="ticket-detail-item">
                <span className="ticket-detail-label">Fecha apertura</span>
                <span className="ticket-detail-value">
                  {new Date(ticket.OpenAt).toLocaleString('es-ES')}
                </span>
              </div>
              <div className="ticket-detail-item">
                <span className="ticket-detail-label">Máquina</span>
                <span className="ticket-detail-value">
                  {ticket.Machine ? ticket.Machine.Serial : 'N/A'}
                </span>
              </div>
              <div className="ticket-detail-item">
                <span className="ticket-detail-label">Prioridad</span>
                <span className="ticket-detail-value">
                  {PRIORITY_LABELS[ticket.Priority] || ticket.Priority}
                </span>
              </div>
              <div className="ticket-detail-item">
                <span className="ticket-detail-label">Categoría</span>
                <span className="ticket-detail-value">
                  {CATEGORY_LABELS[ticket.Category] || ticket.Category}
                </span>
              </div>
              {ticket.Executor &&
                <div className="ticket-detail-item">
                  <span className="ticket-detail-label">Asignado a</span>
                  <span className="ticket-detail-value">{ticket.Executor.fullname}</span>
                </div>
              }
              {ticket.ReviewedAt &&
                <div className="ticket-detail-item">
                  <span className="ticket-detail-label">En Revisión</span>
                  <span className="ticket-detail-value">
                    {new Date(ticket.ReviewedAt).toLocaleString('es-ES')}
                    {ticket.ReviewedBy ? ` — ${ticket.ReviewedBy.fullname}` : ''}
                  </span>
                </div>
              }
              {ticket.InIncidenceAt &&
                <div className="ticket-detail-item">
                  <span className="ticket-detail-label">En Incidencia</span>
                  <span className="ticket-detail-value">
                    {new Date(ticket.InIncidenceAt).toLocaleString('es-ES')}
                    {ticket.InIncidenceBy ? ` — ${ticket.InIncidenceBy.fullname}` : ''}
                  </span>
                </div>
              }
              {ticket.InRepairAt &&
                <div className="ticket-detail-item">
                  <span className="ticket-detail-label">En Reparación</span>
                  <span className="ticket-detail-value">
                    {new Date(ticket.InRepairAt).toLocaleString('es-ES')}
                    {ticket.InRepairBy ? ` — ${ticket.InRepairBy.fullname}` : ''}
                  </span>
                </div>
              }
              {ticket.ResolvedAt &&
                <div className="ticket-detail-item">
                  <span className="ticket-detail-label">Resuelto</span>
                  <span className="ticket-detail-value">
                    {new Date(ticket.ResolvedAt).toLocaleString('es-ES')}
                    {ticket.ResolvedBy ? ` — ${ticket.ResolvedBy.fullname}` : ''}
                  </span>
                </div>
              }
              {ticket.ClosedAt &&
                <div className="ticket-detail-item">
                  <span className="ticket-detail-label">Cerrado</span>
                  <span className="ticket-detail-value">
                    {new Date(ticket.ClosedAt).toLocaleString('es-ES')}
                    {ticket.ClosedBy ? ` — ${ticket.ClosedBy.fullname}` : ''}
                  </span>
                </div>
              }
            </div>
            {ticket.Description &&
              <div>
                <span className="ticket-detail-label">Descripción completa</span>
                <div className="ticket-detail-incidence">{ticket.Description}</div>
              </div>
            }
            {ticket.Observations &&
              <div style={{ marginTop: 10 }}>
                <span className="ticket-detail-label">Observaciones</span>
                <div className="ticket-detail-incidence">{ticket.Observations}</div>
              </div>
            }
          </div>
        )}
      </div>
    )
  }

  renderCreateForm() {
    const { machines } = this.props
    const { isSubmitted, formMachine, formCategory, formPriority, formDescription, formError, submitting } = this.state

    if (isSubmitted) {
      return (
        <div className="ticket-create-card">
          <div className="ticket-create-card-header">
            <h3><i className="fas fa-check-circle"></i> Ticket Enviado</h3>
          </div>
          <div className="ticket-success-message">
            <div className="ticket-success-icon">
              <i className="fas fa-check"></i>
            </div>
            <h4>¡Ticket creado correctamente!</h4>
            <p>Lo revisaremos a la mayor brevedad posible para darte una solución.</p>
            <p>En caso de avería urgente, contacta con soporte:</p>
            <div className="support-phone">
              <i className="fas fa-phone-alt"></i>
              +34 93 831 37 91
            </div>
            <p style={{ fontSize: 12, color: '#999' }}>Lunes a Viernes, 9:00h a 17:00h</p>
            <button className="ticket-success-new-btn" onClick={this.resetForm}>
              <i className="fas fa-plus mr-1"></i> Crear otro ticket
            </button>
          </div>
        </div>
      )
    }

    return (
      <div className="ticket-create-card">
        <div className="ticket-create-card-header">
          <h3><i className="fas fa-plus-circle"></i> Nuevo Ticket</h3>
          <p>Describe la incidencia para que podamos ayudarte</p>
        </div>
        <div className="ticket-create-card-body">
          <form onSubmit={this.submit}>
            <div className="form-group">
              <label htmlFor="machine-select">Máquina</label>
              <select id="machine-select"
                value={formMachine}
                onChange={e => this.setState({ formMachine: e.target.value })}>
                <option value="">Selecciona una máquina...</option>
                {machines && machines.map(machine => (
                  <option value={machine._id} key={machine._id}>
                    {machine.Serial}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="category-select">Categoría</label>
              <select id="category-select"
                value={formCategory}
                onChange={e => this.setState({ formCategory: e.target.value })}>
                <option value="">Indica el fallo...</option>
                <option value="COINS">Pago Monedas</option>
                <option value="BILLS">Pago Billetes</option>
                <option value="TPV">Pago Tarjeta</option>
                <option value="SCREEN_OFF">Pantalla Apagada</option>
                <option value="SCREEN_BREAK">Pantalla Rota</option>
                <option value="SCREEN_TOUCH">Táctil No Responde</option>
                <option value="PRINTER_TICKET">Impresora Ticket</option>
                <option value="KIOSC_DOOR">Kiosco Puerta</option>
                <option value="KIOSC_OFF">Kiosco No Enciende</option>
                <option value="OTHER">Otro</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="priority-select">Prioridad</label>
              <select id="priority-select"
                value={formPriority}
                onChange={e => this.setState({ formPriority: e.target.value })}>
                <option value="LOW">Baja</option>
                <option value="MEDIUM">Media</option>
                <option value="HIGH">Alta</option>
                <option value="CRITICAL">Crítica</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="description-text">Descripción</label>
              <textarea id="description-text"
                placeholder="Describe la incidencia con el mayor detalle posible..."
                value={formDescription}
                onChange={e => this.setState({ formDescription: e.target.value })}
                rows="4" />
            </div>

            {formError &&
              <div className="alert alert-danger" style={{ fontSize: 13, padding: '8px 12px', borderRadius: 8 }}>
                {formError}
              </div>
            }

            <button className="ticket-create-submit" type="submit" disabled={submitting}>
              {submitting ? (
                <><i className="fas fa-spinner fa-spin"></i> Enviando...</>
              ) : (
                <><i className="fas fa-paper-plane"></i> Crear Ticket</>
              )}
            </button>
          </form>
        </div>
      </div>
    )
  }

  render() {
    const { machines, loading } = this.props
    const { activeFilter } = this.state

    if (!machines) {
      return <LoadingProgress />
    }

    const filteredTickets = this.getFilteredTickets()
    const counts = this.getStatusCounts()
    const totalOpen = (counts.OPEN || 0) + (counts.ONPROCESS || 0) + (counts.REVIEWED || 0) + (counts.RESOLVED || 0)

    return (
      <div className="support-ticket-customer-view">
        {/* Header */}
        <div className="support-ticket-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-headset mr-3"></i>
                Soporte Técnico
                <span className="subtitle-inline ml-3"> — Gestiona tus incidencias</span>
              </h1>
            </div>
            <div className="header-stats">
              <div className="stat-badge open">
                <i className="fas fa-folder-open"></i>
                {totalOpen} abiertos
              </div>
              {counts.ONPROCESS > 0 &&
                <div className="stat-badge process">
                  <i className="fas fa-cog"></i>
                  {counts.ONPROCESS} en proceso
                </div>
              }
              {counts.RESOLVED > 0 &&
                <div className="stat-badge resolved">
                  <i className="fas fa-check"></i>
                  {counts.RESOLVED} resueltos
                </div>
              }
              <div className="stat-badge closed">
                <i className="fas fa-archive"></i>
                {counts.CLOSED || 0} cerrados
              </div>
            </div>
          </div>
        </div>

        {/* Split layout */}
        <div className="support-ticket-split">
          {/* LEFT — Ticket List */}
          <div className="ticket-list-panel">
            <h4 className="panel-title">
              <i className="fas fa-list-alt"></i>
              Mis Tickets
            </h4>

            <div className="ticket-filter-tabs">
              {FILTER_TABS.map(tab => (
                <button key={tab.key}
                  className={`ticket-filter-tab ${activeFilter === tab.key ? 'active' : ''}`}
                  onClick={() => this.setState({ activeFilter: tab.key, expandedTicket: null })}>
                  {tab.label}
                  {tab.key !== 'ALL' && counts[tab.key] > 0 &&
                    <span style={{ marginLeft: 4 }}>({counts[tab.key]})</span>
                  }
                </button>
              ))}
            </div>

            {loading ? (
              <LoadingProgress />
            ) : filteredTickets.length > 0 ? (
              filteredTickets.map(ticket => this.renderTicketCard(ticket))
            ) : (
              <div className="ticket-empty-state">
                <i className="fas fa-ticket-alt"></i>
                <h3>No hay tickets {activeFilter !== 'ALL' ? `con estado "${STATUS_LABELS[activeFilter]}"` : ''}</h3>
                <p>Crea un nuevo ticket desde el panel de la derecha</p>
              </div>
            )}
          </div>

          {/* RIGHT — Create Form */}
          <div className="ticket-create-panel">
            {this.renderCreateForm()}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  machines: state.machines.machines,
  auth: state.auth,
  id: state.auth.id,
  supporttickets: state.supporttickets.supporttickets,
  loading: state.supporttickets.loading,
  supportticketNeedRefresh: state.supporttickets.supportticketNeedRefresh
})

const mapDispatchToProps = dispatch => ({
  addSupportTicket: bindActionCreators(addSupportTicket, dispatch),
  fetchMachines: bindActionCreators(fetchMachines, dispatch),
  fetchSupportTickets: bindActionCreators(fetchSupportTickets, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(SupportTicketAddForm)

